'use es6';

import { memo } from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedPhoneNumber from 'I18n/components/FormattedPhoneNumber';
import PropTypes from 'prop-types';
import { getExtension, getPhoneNumber, getMetadata, getPropertyName, getValue } from 'calling-lifecycle-internal/callees/operators/calleesOperators';
import { PhoneNumberProperty } from 'calling-lifecycle-internal/callees/records/CalleesRecordsTyped';
import { getPropertyLabel } from 'calling-lifecycle-internal/callees/operators/getPhoneNumberPropertyLabel';

/**
 * Generic phoneNumber formatting with a property name
 * ex: +1 (555) 555-5555, ext. 123 (Phone Number)
 */
import { jsx as _jsx } from "react/jsx-runtime";
function PhoneNumberWithProperty({
  phoneNumberProperty,
  hidePropertyName
}) {
  const propertyName = getPropertyName(phoneNumberProperty);
  const phoneNumberMetadata = getMetadata(phoneNumberProperty);
  const phoneNumber = getPhoneNumber(phoneNumberMetadata);
  const extension = getExtension(phoneNumberMetadata);
  const translatedPropertyLabel = getPropertyLabel(phoneNumberProperty);
  if (!phoneNumber) {
    const rawPhoneNumber = getValue(phoneNumberProperty);
    if (!rawPhoneNumber) {
      return translatedPropertyLabel || propertyName;
    }
    if (hidePropertyName) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "callee-phone-numbers.hidePropertyName.rawNumberOption",
        options: {
          rawPhoneNumber
        }
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "callee-phone-numbers.rawNumberOption",
      options: {
        rawPhoneNumber,
        propertyName: translatedPropertyLabel || propertyName
      }
    });
  }
  if (hidePropertyName) {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "callee-phone-numbers.hidePropertyName.numberOption_jsx",
      options: {
        phoneNumber,
        extension
      },
      elements: {
        FormattedPhoneNumber
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "callee-phone-numbers.numberOption_jsx",
    options: {
      phoneNumber,
      extension,
      propertyName: translatedPropertyLabel || propertyName
    },
    elements: {
      FormattedPhoneNumber
    }
  });
}
PhoneNumberWithProperty.propTypes = {
  phoneNumberProperty: PropTypes.instanceOf(PhoneNumberProperty).isRequired,
  hidePropertyName: PropTypes.bool
};
export default /*#__PURE__*/memo(PhoneNumberWithProperty);